// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBsp-ouxZmuNjiq3Ji6F5uoqJoC--Cl4YI",
    authDomain: "ivfggrc-6ed68.firebaseapp.com",
    projectId: "ivfggrc-6ed68",
    storageBucket: "ivfggrc-6ed68.appspot.com",
    messagingSenderId: "569847306498",
    appId: "1:569847306498:web:e0794f89517ebd8e2b8a1b",
    measurementId: "G-BBZSRJ5FTD",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
export { auth, db };
